import { CSSProperties, useMemo } from 'react';

import { WidgetItemAspectRatio, WidgetItemAspectRatioDefault, valueForAspecRatio } from '@vestico/model';

import { BorderRadiusStyles, CustomCSSProperties, useImageBorderStyles } from '@vestico/shared';

export const ROW_LAYOUT_ITEM_SIZE_KEY = '--vw-rowlayout-item-size';
export const ROW_LAYOUT_ITEM_BORDER_RADIUS_KEY = '--vw-rowlayout-item-border-radius';

export interface CarouselStylesProps {
  customCSS?: CSSProperties;
  aspectRatio?: WidgetItemAspectRatio;
  borderRadius?: number | string;
  itemSize?: number;
}

export const useCarouselStyles = ({ customCSS, aspectRatio, borderRadius: borderRadiusValue, itemSize }: CarouselStylesProps) => {
  const borderStyles = useImageBorderStyles([`var(${ROW_LAYOUT_ITEM_BORDER_RADIUS_KEY})`]);

  const borderRadius = useMemo(() => {
    if (borderRadiusValue !== undefined) {
      if (typeof borderRadiusValue === 'number' && !Number.isNaN(borderRadiusValue)) {
        return `${borderRadiusValue}px`;
      }
      if (typeof borderRadiusValue === 'string') {
        return borderRadiusValue;
      }
    }

    return 'var(--image-viewer-border-radius-default)';
  }, [borderRadiusValue]);

  const styles = useMemo(() => {
    const css: CustomCSSProperties = { ...borderStyles, ...customCSS };
    css['--carousel-item-aspect-ratio'] = valueForAspecRatio(aspectRatio ?? WidgetItemAspectRatioDefault);
    if (itemSize && !Number.isNaN(itemSize)) {
      css[ROW_LAYOUT_ITEM_SIZE_KEY] = `${itemSize}px`;
    }

    if (borderRadius !== undefined) {
      css[ROW_LAYOUT_ITEM_BORDER_RADIUS_KEY] = borderRadius;
    }

    return css;
  }, [borderStyles, customCSS, aspectRatio, itemSize, borderRadius]);

  const borderRadiusStyles: BorderRadiusStyles | undefined = useMemo(() => (borderRadius ? [borderRadius] : undefined), [borderRadius]);

  return { styles, borderRadiusStyles };
};
